import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import { UPDATE_CHANNEL_TEAM } from "../../../graphql/mutations/channel-team";
import { handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useChannelTeamCtx } from "../context";
import ChannelTeamForm from "../channel-team-form";

export default function ChannelTeamUpdate({ open, onClose, node }) {
    const { refetch } = useChannelTeamCtx();
    const { toggleToast, setNotify } = useToastContext();

    const [setDelay] = useTimeout();
    const [updateChannelTeam, { loading }] = useMutation(UPDATE_CHANNEL_TEAM, {
        onCompleted: () => {
            setNotify({ msg: "Update Channel Team successfully", err: false });

            onClose();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const formRef = React.useRef(null);
    const handleSubmit = useCallback(() => {
        if (!node?.id) return;

        if (!formRef.current || !formRef.current.getState) return;
        const input = formRef.current.getState();
        if (!input) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        updateChannelTeam({
            variables: {
                input: {
                    ...input,
                    id: node.id,
                },
            },
        });
    }, [updateChannelTeam, toggleToast, setNotify, node]);

    return (
        <Modal
            title="Update Channel Team"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
        >
            <ChannelTeamForm value={node} ref={formRef} />
        </Modal>
    );
}
